import { Button } from "@coolset/cs-ui";
import { Dialog, DialogActions, Typography } from "@mui/material";
import React, { useState } from "react";

interface BulkDeleteDialogProps {
  count: number;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const BulkDeleteDialog = (props: BulkDeleteDialogProps) => {
  const { count, onConfirm, onCancel } = props;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onCancel} PaperProps={{ className: "layout-block-required-dialog" }}>
      <div className="_d-grid-md-gap">
        <Typography variant="h4">Delete {count} cells?</Typography>
        <Typography color="text.secondary">
          This permanently removes the selected cells and their questions. This cannot be undone.
        </Typography>
      </div>
      <DialogActions sx={{ mt: 2 }}>
        <Button onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} loading={loading} color="error">
          Delete {count} cells
        </Button>
      </DialogActions>
    </Dialog>
  );
};
